import queryString from 'querystring';

/* global window */

export default class UrlHelper {
    static getQueryParamValue(key, url = window.location.search) {
        if (url.charAt(0) === '?') {
            url = url.substring(1);
        }
        const params = queryString.parse(url);
        return params[key];
    }

    static generateQueryString(params) {
        return queryString.stringify(params);
    }

    static isRunningOnDeveloperMachine() {
        return /^https?:\/\/localhost/.test(window.location);
    }
}



// WEBPACK FOOTER //
// ./helpers/url-helper.js